export const PRODUCT_CODES = ["CREATOR_30D", "SCREEN_SHARE_30D"] as const;
export type ProductCode = (typeof PRODUCT_CODES)[number];
export type PlanCode = "FREE" | ProductCode;
export type PriceTier = "FIRST_PURCHASE" | "REPURCHASE";

export interface ProductDefinition {
  code: ProductCode;
  name: string;
  description: string;
  firstPurchaseAmountFen: number;
  repurchaseAmountFen: number;
  quotaTotal: number;
  durationDays: number;
}

export const PRODUCTS: readonly ProductDefinition[] = [
  {
    code: "CREATOR_30D",
    name: "BUFF创作者 30 天权益包",
    description: "为高频创作与高清交付而生",
    firstPurchaseAmountFen: 990,
    repurchaseAmountFen: 1490,
    quotaTotal: 200,
    durationDays: 30,
  },
  {
    code: "SCREEN_SHARE_30D",
    name: "屏幕分享创作者 30 天权益包",
    description: "满足你更多个性化需求",
    firstPurchaseAmountFen: 1880,
    repurchaseAmountFen: 2550,
    quotaTotal: 500,
    durationDays: 30,
  },
];

export function getProduct(code: string): ProductDefinition | undefined {
  return PRODUCTS.find((product) => product.code === code);
}

export function planName(code: PlanCode): string {
  return code === "FREE" ? "体验版" : getProduct(code)!.name;
}

export function formatAmount(amountFen: number, fixed = false): string {
  const value = (amountFen / 100).toFixed(2);
  return fixed ? value : value.replace(/\.?0+$/, "");
}
